import urlParamsToObject from '../../utils/url/urlParamsToObject';
import removePrefixFromParams from '../../utils/url/removePrefixFromParams';
import * as URL from './_trackUrlParams';

/**
 * @private
 * Reset values in the storage when some URL parameters change.
 *
 * @param {Object} hcStorage: the `hc` object to be updated
 */
export default function updateChangesInUrl(hcStorage) {
  const urlParams = removePrefixFromParams(urlParamsToObject(), 'p.');
  let obj, prop, param;
  URL.TRACK_CHANGES.forEach((key) => {
    obj = hcStorage;
    prop = URL.MAP_KEYS[key] || key;
    if (key.indexOf('utm_') === 0) obj = hcStorage.utm;
    param = urlParams[key] || urlParams[key.toLowerCase()] || urlParams[key.toUpperCase()];
    if (param !== obj[prop]) {
      obj[prop] = '';
    }
  });
}
